import { jsx as _jsx } from "react/jsx-runtime";
import './QColorPicker.scss';
export const QColorPicker = () => {
    return (_jsx("input", { type: "color", className: 'q-color-picker' }));
};
//# sourceMappingURL=QColorPicker.js.map